'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NonStandardAction = undefined;
exports.default = createReducer;

var _fluxStandardAction = require('flux-standard-action');

var _ramda = require('ramda');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NonStandardAction = exports.NonStandardAction = function NonStandardAction(action) {
  var _this = this;

  _classCallCheck(this, NonStandardAction);

  this.action = action;
  this.message = 'attempting to handle an action that is not a flux-standard-action';
  this.stack = new Error().stack;
  this.toString = function () {
    return _this.message + ': ' + JSON.stringify(_this.action);
  };
};

var throwIfNotFSA = function throwIfNotFSA(action) {
  var isWhitelisted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _ramda.always)(false);

  if (isWhitelisted(action) || (0, _fluxStandardAction.isFSA)(action)) return;

  throw new NonStandardAction(action);
};

// eslint-disable-next-line no-process-env
var isProduction = process.env.NODE_ENV === 'production';
var ensureIsFSA = isProduction ? _ramda.identity : throwIfNotFSA;

function createReducer(initialState, handlers) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    ensureIsFSA(action, options.allowNonStandardActionIf);

    return (0, _ramda.propOr)(_ramda.identity, action.type, handlers)(state, action);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/zeal-redux-utils/lib/createReducer.js
// module id = 1198
// module chunks = 0